import React from "react";
import cx from "classnames";
import { WarningAmberRounded, ErrorOutlineRounded, InfoOutlined } from "@mui/icons-material";

export const MappingWarningIcon = () => (
  <div className="mapping__icon mapping__icon--warning">
    <WarningAmberRounded />
  </div>
);

export const MappingErrorIcon = () => (
  <div className="mapping__icon mapping__icon--error">
    <ErrorOutlineRounded />
  </div>
);

export const MappingInfoIcon = ({ light }) => (
  <div
    className={cx("mapping__icon mapping__icon--info", {
      "mapping__icon--white": light,
    })}
  >
    <InfoOutlined />
  </div>
);
